import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { CommonService } from './../../../common/services/common.service';
import { PromoContentService } from '../../../core/routing/services/asset-library/promo-content.service';
import { PromoContent, PromoContentConfiguration} from '../../asset-library/promo-content/interfaces/promo-content.i';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { ProfileUpdateResponse, PromotionalContent } from '../../create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { LanguageConstants } from '../../header/constants/lang.consts';
import { DevicesService } from '../../../../app/core/routing/services/devices/devices.service';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { Utils } from '../../../common/utils/utils';
@Component({
  selector: 'iposcen-push-promos',
  templateUrl: './push-promos.component.html',
  styleUrls: ['./push-promos.component.scss']
})
export class PushPromosComponent implements OnInit {
  globalconst = GlobalConstants;
  editCheck: boolean;
  allPromoContentGroups: PromoContent[];
  displayPromoContentGroups = [];
  pushPromos = [];
  prevPushPromos = [];
  configurations: PromoContentConfiguration[];
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailerUserId = sessionStorage.getItem('retailerId');
  retailerName = sessionStorage.getItem('retailerName');
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  presentPage: string;
  sendButtonText: string;
  promoContentIdInfo: string;
  sendNameToStore: string;
  retailHQUser: string;
  isRetailerUser: boolean;
  isSendToStore = false;
  details: string = ' Details';
  profilePage: string = GlobalConstants.PROFILE;
  assetsPage: string = GlobalConstants.ASSET_LIBRARY;
  sortValue = GlobalConstants.CREATED_DATE;
  page = 1;
  pageSize = 5;
  maxSize = 5;
  profileDataResponse: ProfileUpdateResponse;
  selctedContGrpsForProfile: any = {
    contentGrps: [],
    showOnDevice: []
  };
  showDevice = false;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
  + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  pageGrpForm: any;
  yesLabel: string = GlobalConstants.YES;
  noLabel: string = GlobalConstants.NO;
  internalName = GlobalConstants.INTERNAL_NAME;
  isStoreUser: boolean;
  isRegionalHQ: boolean;
  showonDeviceLimit = GlobalConstants.SHOW_ON_DEVICE_LIMIT;
  addToPackageLimit = GlobalConstants.ADD_TO_PACKAGE_LIMIT;
  newContentGrpDataToNavigate: any;
  newPromoContentTitle: string = $localize`:@@promo-content.tab-pane.new-promo-content-group:NEW PROMOTIONAL CONTENT GROUP`;
  noPromoCreatedDescription: string = $localize`:@@promo-content.no-promo-desc:No Promotional Content Group has been created.`;
  changePlacement: boolean;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  promoContentLabel = GlobalConstants.PROMO_CONTENT_GROUP_TEXT;
  openModalPopup = false;
  successMessage = '';
  description = '';
  noPromos:boolean = false;
  isDataLoading:boolean = false;
  isIdleExperienceEnabled:string = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  isCheckedPreview: boolean;
  previewTabIndex:number = 0;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private cmnService: CommonService,
    private promoContentService: PromoContentService,
    public deviceSettingService: DevicesService
  ) { }
  
  ngOnInit(): void {
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    this.isCheckedPreview = true;
    this.retailHQUser = sessionStorage.getItem('userRole');
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser') || false;
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ') || false;
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER) || false;
    this.presentPage = GlobalConstants.PROFILE;
    this.getAllPromoContentsByUser();
  }

  previewNavigate(ind){
    this.previewTabIndex = ind;
    this.selctedContGrpsForProfile = {
      contentGrps: [],
      showOnDevice: []
    };
    this.setData();
  }

  getAllPromoContentsByUser() {
    this.pushPromos = [];
    this.displayPromoContentGroups=[];
    this.prevPushPromos=[];
    this.editCheck = false;
    this.noPromos = false;
    this.promoContentService.getAllPromoContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllPromoContentResponse => {
        //Note: Below code is temp sol. will be changed later.
        if(this.isRegionalHQ){
          let sameRetPromos=[];
          let tempPromos = (getAllPromoContentResponse.promotionalContent as PromoContent[]);
          for(let i=0;i<tempPromos?.length;i++){
            if(!tempPromos[i]?.retailerId || tempPromos[i]?.retailerId && tempPromos[i]?.retailerId == this.retailerUserId){
              sameRetPromos.push(tempPromos[i]);
            }
          }
          this.pushPromos = [...sameRetPromos];
        }else{
          this.pushPromos = (getAllPromoContentResponse.promotionalContent as PromoContent[]);
        }
        // display Promo content groups using displayPromocontentgroups var as configurations is coming as string
        this.pushPromos.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
        });
        this.pushPromos.forEach(element => {
          // adding this custom property to know which Promo content is expanded
          element.isExpanded = false;
          element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          if (element && element.configurations && element.configurations.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          // converting date format:
          if (element && element.configurations) {
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
              //changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              //changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
          }
          // converting date for display purpose:
          element.showOnDevice = false;
          element.addToPackage = false;
          //For previously pushed promos tab data
          if(this.isRegionalHQ){
            if(element?.pushToNewDevice && element?.pushToNewDevice === "true" && element?.retailerId == this.retailerUserId){
              this.prevPushPromos.push(element);
            }
          }
          else if(element?.pushToNewDevice && element?.pushToNewDevice === "true"){
            this.prevPushPromos.push(element);
          }
            // For content expired notification
            element.isContentExpires = Utils.getExpiredContentdata(element);
        });
        this.setData();
      },
        error => {
          // If any error in promos API call UI will show no promos erros msg
          this.noPromos = true;
        });
  }

  sortByDate() {
    this.page = 1;
    this.sortValue = GlobalConstants.CREATED_DATE;
    this.displayPromoContentGroups.sort((promo1, promo2) => promo2.updateTime - promo1.updateTime);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      "promotionalContentId": this.displayPromoContentGroups[ind].id,
      "showOnDevice": this.displayPromoContentGroups[ind].showOnDevice
    });
  }
  // minipreview image or video content
  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url +
          AssetLibraryConstants.PROMO_CONTENTS +
          AssetLibraryConstants.SLASH + gId +
          AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 1,
      previewType: pageContent ? pageContent.previewType : '',
      idleExpFullscreenEnabled: pageContent ? pageContent.idleExpFullscreenEnabled : '',
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,
    };

    return this.pageGrpForm;
  }
  getFontSize(size: number) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }
  getDetailsOfPromoCG(id: string) {
    this.displayPromoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        this.cmnService.scrollToBottom(id);
      }
    });
    this.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  }
  // This function gets called when user selects/deselect show on device / addToPackage
  addToProfile(eventObj: any, index: number, eventSource: string) {
    // if or show on device
    if (eventSource === GlobalConstants.SHOW_ON_DEVICE) {
      if (eventObj.target.checked) {
        this.pushToSelectedGrps(index);
        this.selctedContGrpsForProfile.showOnDevice.push(this.displayPromoContentGroups[index].id);
        const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.promotionalContentId === this.displayPromoContentGroups[index].id);
        this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = true;
        this.displayPromoContentGroups[index].showOnDevice = true;
      } else {
        this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice
          .filter(item => item !== this.displayPromoContentGroups[index].id);
        const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.promotionalContentId === this.displayPromoContentGroups[index].id);
        if (checkIndContentGrps >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkIndContentGrps, 1);
        }
        this.displayPromoContentGroups[index].showOnDevice = false;
      }
    } else if (eventSource === GlobalConstants.ADD_TO_PACKAGE) { // for add to package
      if (eventObj.target.checked) {
        if (this.selctedContGrpsForProfile.contentGrps?.length <= 6) {
          this.displayPromoContentGroups[index].addToPackage = eventObj.target.checked;
          this.pushToSelectedGrps(index);
        } else {
          eventObj.target.checked = false;
        }
      } else {
        if (this.displayPromoContentGroups[index].showOnDevice) {
          this.selctedContGrpsForProfile.showOnDevice = this.selctedContGrpsForProfile.showOnDevice
            .filter(item => item !== this.displayPromoContentGroups[index].id);
        }
        this.setPackageNshowOnDeviceVal(index, false);
        const checkInd = this.selctedContGrpsForProfile.contentGrps
          .findIndex(d => d.promotionalContentId === this.displayPromoContentGroups[index].id);
        if (checkInd >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
        }
      }
    }
  }
  // this function will be used in multiple places to set addToPackage, showOnDevice to true/false ---> for AddToProfile
  setPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displayPromoContentGroups[index].showOnDevice = this.displayPromoContentGroups[index].addToPackage = value;
  }
  //Push Promos
  sendPromosToDevices(){
    const send = { 
      promotionalContents: this.selctedContGrpsForProfile.contentGrps
    };
    this.deviceSettingService.deviceSettingPatchReq(JSON.stringify(send), this.retailerUserId)
      .pipe(first())
      .subscribe(response => {
        this.openModalPopup = !this.openModalPopup;
        this.successMessage = this.globalconst.PUSH_PROMOS_DELETE_POPUP_HEADER;
        this.description = this.globalconst.PUSH_PROMOS_DELETE_POPUP_SUBTITLE;
        this.selctedContGrpsForProfile = {
          contentGrps: [],
          showOnDevice: []
        };
    });
  }
  closePopup() {
    this.openModalPopup = !this.openModalPopup;
    this.page = 1; // set pagination to 1
    this.getAllPromoContentsByUser();
  }
  setData(){
    if(this.previewTabIndex === 0){
      this.displayPromoContentGroups = [...this.pushPromos];
    }else{
      this.displayPromoContentGroups=[...this.prevPushPromos];
    }
    /*The below condition is to handle 
     when 2nd tab has one promo and user selected and stopped it. 
     In that case UI should switch to first tab since there is no data.
    */
    if(!this.displayPromoContentGroups?.length && this.pushPromos?.length){
      this.previewTabIndex = 0;
      this.displayPromoContentGroups = [...this.pushPromos];
    }
    this.sortByDate();
    for(let i=0;i<this.displayPromoContentGroups?.length;i++){
      this.displayPromoContentGroups[i].index = i;
      this.displayPromoContentGroups[i].showOnDevice = false;
      this.displayPromoContentGroups[i].addToPackage = false;
    };
    //If No Promotional Data 
    if(!this.displayPromoContentGroups?.length){
      this.noPromos = true;
    }
  }
  stopPushPromosToDevices(){
    let sendData = {
      promotionalContentIdList:this.selctedContGrpsForProfile.showOnDevice,
      pushToNewDevice:"false",
      retailerID:this.retailerUserId,
      retailerName: this.retailerName
    }
    this.deviceSettingService.stopUpdatesOnNewDevices(JSON.stringify(sendData))
    .pipe(first())
    .subscribe(response => {
      this.openModalPopup = !this.openModalPopup;
      this.successMessage = this.globalconst.PUSH_PROMOS_STOP_POPUP_HEADER;
      this.description = this.globalconst.PUSH_PROMOS_STOP_POPUP_SUBTITLE;
      this.selctedContGrpsForProfile = {
        contentGrps: [],
        showOnDevice: []
      };
  });

  }
  togglePreviewTabs(previewType, id) {
    this.isIdleExperienceEnabled = previewType;
    this.displayPromoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isIdleExperienceEnabled = this.isIdleExperienceEnabled;
      }
    });
  }
}
